<template>
  <div class="card shadow-lg">
    <div class="card-body">
      <!-- Vertical tabs -->
      <div class="row">
        <div class="col-3">
          <ul class="nav nav-tabs flex-column" role="tablist" style="padding-bottom: 2.5rem;">
            <li class="nav-item">
              <a href="" data-bs-target="#collection-home" data-bs-toggle="tab" role="tab" class="nav-link text-decoration-none active">
                {{ $t('details') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="" data-bs-target="#collection-contents" data-bs-toggle="tab" role="tab" class="nav-link text-decoration-none">
                {{ $t('content') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="" data-bs-target="#tags" data-bs-toggle="tab" role="tab"
                class="nav-link text-decoration-none">
                {{ $t('tags') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="" data-bs-target="#collection-availability" data-bs-toggle="tab" role="tab" class="nav-link text-decoration-none">
                {{ $t('availability') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="" data-bs-target="#collection-privacy" data-bs-toggle="tab" role="tab" class="nav-link text-decoration-none pb-3">
                {{ $t('privacy-and-security') }}
              </a>
            </li>
          </ul>
        </div>
        <div class="col-9">
          <form @submit.prevent="onSubmit" @keydown.enter.prevent.self>
            <div id="myTabContent" class="tab-content">
              <div id="collection-home" role="tabpanel" aria-labelledby="collection-home-tab" class="tab-pane fade show active">
                <div id="input-group-1" class="form-group g-3">
                  <label for="collection_name">{{ $t('network.name') }}</label>
                  <input id="collection_name" v-model="form.name" data-test="name" class="form-control" required placeholder />
                  <p class="alert rounded-1 alert-warning text-black fw-semibold mt-3 py-2 px-3" style="font-size: small;">
                    {{ $t('be-careful-when-updating-the-collection-name-as-it-will-change-the-associated-link-potentially-causing-broken-links-for-prior-shares') }}
                  </p>
                </div>
                <div id="input-group-2" class="form-group mt-3">
                  <label for="collection_description">{{ $t('network.networkForm.description') }}</label>
                  <Editor
                    id="collection_description"
                    v-model="form.description"
                    data-test="collection_description"
                    :api-key="tinyMceApiKey"
                    :init="{
                      height: 300,
                      menubar: false,
                      automatic_uploads: true,
                      browser_spellcheck: true,
                      paste_as_text: true,
                      relative_urls : false,
                      remove_script_host : false,
                      plugins: [
                        'advlist autolink lists link charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help',
                    }"/>
                </div>
                <div id="input-group-3" class="form-group my-3">
                  <label for="collection_publish_date">{{ $t('network.networkForm.publishDate') }}</label><br>
                  <date-picker id="collection_publish_date" v-model="form.publish_date" data-test="collection_publish_date"></date-picker>
                </div>
              </div>
              <div id="collection-contents" role="tabpanel" aria-labelledby="collection-contents-tab" class="tab-pane fade">
                <div v-if="newCollectionFromFiles" id="input-group-4" class="form-group my-3 col-12">
                  <label for="input-4">{{ $t('network.selectMedia') }}</label>
                  <MediaSelector :allowMultiple="true" :existingMedia="form.collection" :networks="form.networks" @media-selected="updateCollectionFormMediaList" />
                </div>
                <div v-if="form.is_organized && !newCollectionFromFiles">
                  <OrganizedTreeEditor
                    v-if="!newCollectionFromFiles"
                    ref="organizedTreeEditor"
                    :collection="form"
                    :managedNetworks="managedNetworks"
                    @update-collection-media-list="updateCollectionFormMediaList"
                  />
                </div>
                <button v-if="form.is_organized && !newCollectionFromFiles" id="save" data-test="save" type="submit" class="btn btn-primary btn-sm mt-2">
                  {{ $t('network.user.save') }}
                </button>
              </div>
              <div id="tags" role="tabpanel" aria-labelledby="tags-tab" class="tab-pane fade">
                <div class="form-group pb-2 ">
                  <label for="suggestTags" class="fw-bold pb-2 opacity-80">{{ $t('network.sortOptions.suggestTags') }}</label>
                  <TagFormField
                    :network_media_collection_id="form.id"
                    @update-collection-tags="updateTags"
                  />
                  <small class="text-muted">{{ $t('recommend-suitable-tags-by-searching-or-adding-them') }}.
                    {{ $t('you-can-use-a-comma-or-a-semicolon-to-separate-multiple-tags') }}
                  </small>
                </div>
                <div v-if="form.tags" class="form-group pb-2">
                  <label class="fw-bold pb-2 opacity-80">
                    <span v-if="form.tags.length == 1">This collection has 1 tag.</span>
                    <span v-else>This collection has {{ form.tags.length }} tags.</span>
                  </label>
                  <br />
                  <div v-for="(tag,index) in sortedArray(form.tags)" :key="index" role="group" aria-label="Basic example" class="btn-group btn-sm p-0 m-1">
                    <span class="bg-primary text-white btn-sm py-0 px-2 rounded-1 rounded-end-0">#{{ tag.name }}</span>
                    <button id="remove_media_tag" data-test="remove_media_tag" type="button" class="btn bg-danger btn-sm py-0 px-2" @click="removeCollectionTag(tag)">
                      <i class="fa fa-close text-white"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div id="collection-availability" role="tabpanel" aria-labelledby="collection-availability-tab" class="tab-pane fade">
                <div id="input-group-12" class="form-group mt-3">
                  <div class="form-group pb-2">
                    <label for="selected_networks" class="fw-bold opacity-80">{{ $t('network.networkForm.selectNetwork') }}</label>
                    <v-select
                      id="selected_networks"
                      v-model="selectNetwork"
                      data-test="selected_networks"
                      :options="sortedArray(managedNetworks)"
                      label="name"
                      :placeholder="$t('network.networkForm.selectNetwork')"
                      :filter="fuseSearch"
                      :get-option-label="option => option.name + ' (' + option.short_name + ')'"
                      multiple
                      @input="cleanNetworkAfterSelection"
                    ></v-select>
                  </div>
                  <div v-if="msg.networkCollection != ''" :class="msg.networkCollectionClass" :style="{display: msg.networkCollectionStyle}">
                    {{ msg.networkCollection }}
                  </div>
                  <div v-if="form.networks" class="form-group py-2">
                    <label v-if="form.networks.length != 0" class="pb-1 fw-bold opacity-80" for="">
                      <span v-if="form.networks.length == 1">{{ $t('media-available-in-1-other-network') }}</span>
                      <span v-else>{{ $t('media-available-in-other-networks', { num: form.networks.length }) }}</span>
                    </label>
                      <ul class="list-group rounded-0 ">
                        <li v-for="(collectionNetwork,index) in sortedArray(form.networks)" :key="index" class="list-group-item ps-1 text-primary"> 
                        <div class="row">
                          <div class="col-10 ps-3">{{ collectionNetwork.name }} </div>
                          <div class="col-1 text-end"><a :href="'/networks/'+collectionNetwork.slug" target="_BLANK"><i class="fa fa-external-link"></i></a></div>
                          <div role="button" class="col-1 text-end" @click="removeNetwork(collectionNetwork)"><i class="fa fa-close text-danger"></i></div>
                        </div>
                        </li>
                      </ul>
                  </div>
                  <div class="alert alert-warning alert-dismissible fade show text-black fw-semibold mt-3" role="alert">
                    <i class="fas fa-exclamation-circle me-1"></i>
                    {{ $t('network.networkMediaForm.applyMissingNetworksToMedia') }}
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                  </div>
                </div>
              </div>
              <div id="collection-privacy" role="tabpanel" aria-labelledby="collection-privacy-tab" class="tab-pane fade">
                <div id="input-group-11" class="form-group mt-3">
                  <label for="input-11">{{ $t('network.networkMediaForm.collection-permission') }}</label>
                  <PermissionList v-model="form.permission" :value="form.permission" title="Choose the level of visibility for this collection" />
                  <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px); margin: 20px 0px;">
                  <div class="form-check form-switch">
                    <input id="can_download_collection" v-model="form.can_download" data-test="can_download_collection" type="checkbox" class="form-check-input" />
                    <label for="can_download_collection" class="form-check-label form-check-lg">Allow download</label>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OrganizedTreeEditor from './OrganizedTreeEditor';
import PermissionList from '../../commons/Networks/PermissionList.vue';
import Selector from '@/components/commons/Media/Selector.vue';
import TagFormField from '@/components/commons/Tags/TagFormField.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Editor from '@tinymce/tinymce-vue';
import Fuse from 'fuse.js';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { split, sortBy, debounce } from 'lodash';

export default {
  components: {
    OrganizedTreeEditor,
    PermissionList,
    MediaSelector: Selector,
    TagFormField,
    DatePicker,
    Editor,
    vSelect,
  },
  props: {
    form: {
      type: Object,
      default: null,
    },
    managedNetworks: {
      type: Array,
      default: null,
    },
    busy: {
      type: Boolean,
      default: false,
    },
    newCollectionFromFiles: {
      type: Boolean,
      default: false,
    },
    brandNewCollection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectNetwork : [],
      searchedMedia: [],
      defaultMediaPermissions: ['public', 'authorized', 'private', 'unlisted'],
      loading: false,
      tinyMceApiKey: process.env.VUE_APP_TINYMCE_API_KEY,
      msg: { 
        networkCollection : '',
        networkCollectionClass : '',
        networkCollectionStyle: 'none',
      },
      doNotRefresh: false,
      initialForm: { ...this.form },
    };
  },
  computed: {
    collectionFormUpdated() {
      return (JSON.stringify(this.form) != JSON.stringify(this.initialForm)) ? true : false;
    }
  },
  watch: {
    collectionFormUpdated(value) {
      this.$emit('collection-form-updated', value);
    },
    'form.name': {
      handler: debounce(function () {
        this.onSubmit();
      }, 3000),
      deep: true,
    },
    'form.description': {
      handler: debounce(function () {
        this.onSubmit();
      }, 3000),
      deep: true,
    },
    'form.publish_date': {
      handler: debounce(function () {
        this.onSubmit();
      }, 3000),
      deep: true,
    },
    'form.permission': {
      handler: debounce(function () {
        this.onSubmit();
      }, 3000),
      deep: true,
    },
    'form.tags': {
      handler: debounce(function () {
        this.onSubmit();
      }, 3000),
      deep: true,
    },
    'form.can_download': {
      handler: debounce(function () {
        this.onSubmit();
      }, 1000),
      deep: true,
    },
  },
  mounted() {
    this.$bus.on('collection-update-event', () => {
      this.onSubmit(false);
    });
    if (this.brandNewCollection == true) {
      this.onSubmit();
    }
  },
  beforeDestroy() {
    this.$bus.off('collection-update-event');
  },
  methods: {
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['name', 'short_name'],
        shouldSort: true,
      });
      return search.length ? fuse.search(search).map(({ item }) => item) : fuse.list;
    },
    updateCollectionFormMediaList(media) {
      this.form.collection.splice(0);
      media.forEach(m => this.form.collection.push(m));
      this.newCollectionFromFiles = false;
    },
    sortedArray(array) {
      return sortBy(array, 'name');
    },
    cleanNetworkAfterSelection() {
      if (this.selectNetwork != '') {
        this.$http.post('networks/collections/'+ this.form.slug +'/network/add', { network : this.selectNetwork }).then(resp => {
          if(resp.data.status){
            this.doNotRefresh = true;
            this.form.networks.push(resp.data.network);
            this.msg.networkCollection = 'Collection successfully added to a network';
            this.msg.networkCollectionClass = 'alert alert-success'; 
            this.msg.networkCollectionStyle = 'block';
            setTimeout(this.removeNetworkAlert, 2000);
          } else {
            this.selectNetwork = '';
          }
        });
      }
    },
    removeNetwork(network) {
      if (this.form.networks.length == 1) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Deleting this collection will remove it from Networks. Contact support if you wish to restore it at a later period of time or felt that you made a mistake.',
          showCancelButton: true,
          confirmButtonText : this.$t('network.delete'),
          customClass: {
            confirmButton: 'btn btn-danger mx-1',
            cancelButton: 'btn btn-primary mx-1',
          },
          buttonsStyling: false
        }).then( (result) => {
          if(result.isConfirmed) {
            this.$swal.fire({
              icon: 'success',
              title: this.$t('success'),
            }).then(() => {
              this.$http.delete('networks/collections/' + this.form.slug).then(() => {
                let path = split(this.$route.fullPath, '/');
                if (path[1] == 'media') {
                  this.$router.push('/media');
                } else {
                  this.$router.push('/networks/' + path[2] + '/media');
                }
              });
            });
          }
        });
      } else {
        this.$swal.fire({
          icon: 'warning',
          title: 'Are you sure about this?',
          showCancelButton: true,
          confirmButtonText : 'Yes, remove',
          customClass: {
            confirmButton: 'btn btn-danger mx-1',
            cancelButton: 'btn btn-primary mx-1',
          },
          buttonsStyling: false
        }).then( (result) => {
          if(result.isConfirmed) {
            this.$http.post('networks/collections/'+ this.form.slug +'/network/remove', { network : network }).then(resp => {
              if(resp){
                this.doNotRefresh = true;
                this.form.networks.splice(this.form.networks.indexOf(network), 1);
                this.msg.networkCollection = 'Network collection removed successfully';
                this.msg.networkCollectionClass = 'alert alert-danger'; 
                this.msg.networkCollectionStyle = 'block';
                setTimeout(this.removeNetworkAlert, 2000);
              }
            });
          }
        });
      }
    },
    removeNetworkAlert() {
      this.selectNetwork = '';
      this.msg.networkCollectionStyle = 'none';
    },
    updateTags(){
      this.$http.get('networks/collections/tags/'+this.form.id).then(resp => {
        if(resp.data.status){
          this.form.tags = resp.data.data;
        }
      });
    },
    removeCollectionTag(tag){
      this.$http.post('networks/collections/tag/remove', { tag : tag, network_media_collection_id : this.form.id }).then(resp => {
        if(resp){
          this.form.tags.splice(this.form.tags.indexOf(tag), 1);
        }
      });
    },
    validate(form) {
      let msg = '';
      if (form.collection.length < 2) msg += this.$t('network.networkForm.atleastTwoDates') + '.\n';

      if (msg.length !== 0) {
        this.$bvModal.msgBoxOk(msg);
        return false;
      }
      return true;
    },
    onSubmit() {
      //if (this.validate(this.form)) {
        //if (this.$refs && this.$refs.organizedTreeEditor) {
          this.form.organized_data = this.$refs.organizedTreeEditor.exportTreeDataToJson();
        //}
        this.$bus.emit('network-media-collection-form-submit', this.form);
      //}
    },
  },
};
</script>
<style scoped>
.vs__dropdown-toggle {
  border-color: #ccc !important;
}
.vs__selected-options {
  padding: 0px 0px 3px 2px;
}
.vs__selected {
  margin: 4px 2px !important;
}
.nav .nav-item .active {
  background-color: #f7f7fc !important;
  border:0px !important;
  border-radius:0px;
  cursor: none;
  font-weight: bold;
}
</style>
<style>
.mx-table {
  width: initial !important;
}
</style>